// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import CollapsibleExpandableController from "./collapsible_expandable_controller"
application.register("collapsible-expandable", CollapsibleExpandableController)

import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)

import ContextMenuController from "./context_menu_controller"
application.register("context-menu", ContextMenuController)

import DatenschutzerklaerungController from "./datenschutzerklaerung_controller"
application.register("datenschutzerklaerung", DatenschutzerklaerungController)

import DatenschutzerklaerungRemoveConsentController from "./datenschutzerklaerung_remove_consent_controller"
application.register("datenschutzerklaerung-remove-consent", DatenschutzerklaerungRemoveConsentController)

import DatenschutzerklaerungSetConsentController from "./datenschutzerklaerung_set_consent_controller"
application.register("datenschutzerklaerung-set-consent", DatenschutzerklaerungSetConsentController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DisableAfterClickController from "./disable_after_click_controller"
application.register("disable-after-click", DisableAfterClickController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FormController from "./form_controller"
application.register("form", FormController)

import InvitationFormController from "./invitation_form_controller"
application.register("invitation-form", InvitationFormController)

import LandingpageController from "./landingpage_controller"
application.register("landingpage", LandingpageController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NoContextMenuController from "./no_context_menu_controller"
application.register("no-context-menu", NoContextMenuController)

import NoCurrentEntryContractController from "./no_current_entry_contract_controller"
application.register("no-current-entry-contract", NoCurrentEntryContractController)

import NoPropagationController from "./no_propagation_controller"
application.register("no-propagation", NoPropagationController)

import ReciprocalRemoveClassController from "./reciprocal_remove_class_controller"
application.register("reciprocal-remove-class", ReciprocalRemoveClassController)

import RemoteContentController from "./remote_content_controller"
application.register("remote-content", RemoteContentController)

import RemoteLinkController from "./remote_link_controller"
application.register("remote-link", RemoteLinkController)

import RemoveClassOnClickOutsideController from "./remove_class_on_click_outside_controller"
application.register("remove-class-on-click-outside", RemoveClassOnClickOutsideController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ScrollToHighlightController from "./scroll_to_highlight_controller"
application.register("scroll-to-highlight", ScrollToHighlightController)

import ScrollToRecordController from "./scroll_to_record_controller"
application.register("scroll-to-record", ScrollToRecordController)

import ShowSchuleInfoController from "./show_schule_info_controller"
application.register("show-schule-info", ShowSchuleInfoController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleByRadioButtonController from "./toggle_by_radio_button_controller"
application.register("toggle-by-radio-button", ToggleByRadioButtonController)

import ToggleBySelectOptionController from "./toggle_by_select_option_controller"
application.register("toggle-by-select-option", ToggleBySelectOptionController)

import ToggleClassOnClickController from "./toggle_class_on_click_controller"
application.register("toggle-class-on-click", ToggleClassOnClickController)

import ToggleVonBisFieldsController from "./toggle_von_bis_fields_controller"
application.register("toggle-von-bis-fields", ToggleVonBisFieldsController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TooltipCustomController from "./tooltip_custom_controller"
application.register("tooltip-custom", TooltipCustomController)

import TurboFrameController from "./turbo_frame_controller"
application.register("turbo-frame", TurboFrameController)

import UserSchulePeopleFormController from "./user_schule_people_form_controller"
application.register("user-schule-people-form", UserSchulePeopleFormController)
